<template>

  <div class="my-4 col-12">

    <div class="col-12">
      <div class="row">
        <div class="col-lg-10 col-12">
          <h6>اشتراک های
            <span class="font-weight-bolder">
        {{ findAttributeOnSiteInfo('site_name')[0] }}
        </span>
          </h6>
        </div>
        <div class="col-lg-2 col-12 text-left">
          <m-a :href='{name:"ModuleInstall"}'>
            <button class="btn btn-primary rounded-pill">نصب ماژول</button>
          </m-a>
        </div>
      </div>


      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">نام اشتراک</th>
            <th scope="col">اعتبار</th>
            <th scope="col">توضیحات</th>
            <th scope="col">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(subscription,index) in subscriptions" :key="index">
            <th>
              {{ subscription.subscription.name }} - {{ subscription.subscriptionItem.name }}
              <span class="badge badge-danger" v-if="checkSubscriptionChargeStatus(subscription)">نیاز به تمدید</span>
            </th>
            <td dir="ltr">{{ chargeTranslator(subscription) }}</td>
            <td>{{ subscription.description }}</td>
            <td>
              <button class="btn btn-primary rounded-pill  mx-1" @click="getRelatedSubscriptions(subscription)"
                      v-b-modal="`subscription-modal-${subscription.id}`">تمدید اشتراک
              </button>

              <b-icon-clock-history v-b-modal="`subscription-charge-history-${subscription.id}`"
                                    class="h5 mx-2 subscription-charge-history"/>

              <b-modal size="lg" :id="`subscription-charge-history-${subscription.id}`" hide-footer>
                <div class="text-right" dir="rtl">
                  <subscription-charge-history request-type="service" :subscription-charge="subscription"/>
                </div>
              </b-modal>

              <template v-if="isAdmin && false">
                <button class="btn btn-primary rounded-pill  mx-1">تغییر اشتراک</button>
                <button class="btn btn-primary rounded-pill  mx-1">شارژ اشتراک به صورت دستی</button>
              </template>

              <b-modal :id="`subscription-modal-${subscription.id}`" size="lg" hide-footer>

                <div class="text-right" dir="rtl">
                  <div class="row">
                    <related-subscription-item v-for="(item,index) in relatedSubscriptions" :key="index"
                                               request-type="service"
                                               :subscriptionCharge="subscription" :item="item" class="col-12"/>

                  </div>
                </div>
              </b-modal>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="text-center">
        <Pagination400 :meta="subscriptionPagination" :on-change-page="getUserSubscriptions"/>
      </div>

    </div>


  </div>

</template>

<script>

import {mapGetters} from "vuex";
import SubscriptionUserOrders from "@/plugin/components/dashboard/Subscription/SubscriptionUserOrders.vue";
import RelatedSubscriptionItem from "@/plugin/components/dashboard/Subscription/RelatedSubscriptionItem.vue";
import SubscriptionChargeHistory from "@/plugin/components/dashboard/SubscriptionCharge/SubscriptionChargeHistory.vue";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import Pagination400 from "@/plugin/miw-components/pagination/Pagination-400.vue";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "ModulesList",
  components: {Pagination400, SubscriptionChargeHistory, RelatedSubscriptionItem, SubscriptionUserOrders},
  data() {
    return {
      subscriptions: [],
      subscriptionPagination: {},
      relatedSubscriptions: [],
    }
  },
  computed: {
    ...mapGetters({
      profileId: "User/getUserId",
      userId: "User/getUserId",
      isAdmin: "User/isAdmin"
    })
  },
  methods: {
    findAttributeOnSiteInfo,
    async getUserSubscriptions(page = 1) {
      let form = {
        page: page,
        user_id: this.profileId
      }
      let req = await this.$store.dispatch('DashboardSubscription/getUserSubscriptions', form)
      // this.subscriptions
      let data = req.data.data
      this.subscriptions = data.data
      this.subscriptionPagination = data.meta
    },
    chargeTranslator(subscription) {
      // if subscription type was date we convert it
      // else we return actual value

      let subscriptionItem = subscription.subscriptionItem
      let subscriptionValue = subscription.value
      if (subscription.subscription.value_type === 'date') {
        return dateConverter(subscriptionValue, '/', true)
      }

      return subscriptionValue
    },
    async getRelatedSubscriptions(subscription) {
      this.relatedSubscriptions = []

      let form = {
        subscription_charge_id: subscription.id,
      }

      let req = await this.$store.dispatch('DashboardSubscription/getRelatedSubscriptions', form)

      this.relatedSubscriptions = req.data.data

    },
    checkNumberTypeSubscription(subscription) {
      return subscription.value < 100
    },
    checkDateTypeSubscription(subscription) {

      let givenDate = new Date(subscription.value);

      let now = new Date();

      let futureDate = new Date();
      futureDate.setDate(now.getDate() + 10);

      if (givenDate > futureDate) {
        return false
      }
      return true

    },
    checkSubscriptionChargeStatus(subscription) {
      let subscriptionType = subscription.subscription.value_type
      if (subscriptionType === 'number') {
        return this.checkNumberTypeSubscription(subscription)
      }
      if (subscriptionType === 'date') {
        return this.checkDateTypeSubscription(subscription)
      }
      return false
    },
  },
  mounted() {
    this.getUserSubscriptions()
  },
}
</script>

<style scoped>

</style>